var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Browser, Complex, Collection } from '@syncfusion/ej2-base';
/**
 * The `Connector` class configures the appearance and properties of connectors in chart controls.
 */
export class Connector extends ChildProperty {
}
__decorate([
    Property('Line')
], Connector.prototype, "type", void 0);
__decorate([
    Property(null)
], Connector.prototype, "color", void 0);
__decorate([
    Property(1)
], Connector.prototype, "width", void 0);
__decorate([
    Property(null)
], Connector.prototype, "length", void 0);
__decorate([
    Property('')
], Connector.prototype, "dashArray", void 0);
/**
 * Configures the location for the legend and tooltip in the chart.
 */
export class Location extends ChildProperty {
}
__decorate([
    Property(0)
], Location.prototype, "x", void 0);
__decorate([
    Property(0)
], Location.prototype, "y", void 0);
/**
 * The `Accessibility` class configures accessibility options for chart controls.
 */
export class Accessibility extends ChildProperty {
}
__decorate([
    Property(null)
], Accessibility.prototype, "accessibilityDescription", void 0);
__decorate([
    Property(null)
], Accessibility.prototype, "accessibilityRole", void 0);
__decorate([
    Property(true)
], Accessibility.prototype, "focusable", void 0);
__decorate([
    Property(0)
], Accessibility.prototype, "tabIndex", void 0);
/**
 * The `SeriesAccessibility` class configures accessibility options specifically for chart series elements.
 */
export class SeriesAccessibility extends Accessibility {
}
__decorate([
    Property(null)
], SeriesAccessibility.prototype, "accessibilityDescriptionFormat", void 0);
/**
 * The `Font` class provides configuration options for customizing the fonts used in the charts.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property('16px')
], Font.prototype, "size", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('')
], Font.prototype, "color", void 0);
__decorate([
    Property('Center')
], Font.prototype, "textAlignment", void 0);
__decorate([
    Property('Segoe UI')
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property(1)
], Font.prototype, "opacity", void 0);
__decorate([
    Property('Wrap')
], Font.prototype, "textOverflow", void 0);
/**
 * The `StackLabelsFont` class provides configuration options for customizing the font properties of stack labels in charts.
 */
export class StackLabelsFont extends ChildProperty {
}
__decorate([
    Property('Normal')
], StackLabelsFont.prototype, "fontStyle", void 0);
__decorate([
    Property('16px')
], StackLabelsFont.prototype, "size", void 0);
__decorate([
    Property('Normal')
], StackLabelsFont.prototype, "fontWeight", void 0);
__decorate([
    Property('')
], StackLabelsFont.prototype, "color", void 0);
__decorate([
    Property('Center')
], StackLabelsFont.prototype, "textAlignment", void 0);
__decorate([
    Property('Segoe UI')
], StackLabelsFont.prototype, "fontFamily", void 0);
__decorate([
    Property(1)
], StackLabelsFont.prototype, "opacity", void 0);
/**
 * Options to customize the center label of the Pie and Donut charts.
 *
 * @default {}
 */
export class CenterLabel extends ChildProperty {
}
__decorate([
    Property(null)
], CenterLabel.prototype, "text", void 0);
__decorate([
    Complex({ fontFamily: null, size: '16px', fontStyle: 'Normal', fontWeight: '600', color: null }, Font)
], CenterLabel.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], CenterLabel.prototype, "hoverTextFormat", void 0);
/**
 * The `Border` class provides configuration options for setting the borders in a chart.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('')
], Border.prototype, "color", void 0);
__decorate([
    Property(1)
], Border.prototype, "width", void 0);
__decorate([
    Property('')
], Border.prototype, "dashArray", void 0);
/**
 * The `Offset` class provides options to adjust the position of the marker relative to its default location.
 */
export class Offset extends ChildProperty {
}
__decorate([
    Property(0)
], Offset.prototype, "x", void 0);
__decorate([
    Property(0)
], Offset.prototype, "y", void 0);
/**
 * The `Margin` class enables configuration of the space around the chart's content.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], Margin.prototype, "bottom", void 0);
/**
 * Configures the animation behavior for the chart series.
 */
export class Animation extends ChildProperty {
}
__decorate([
    Property(true)
], Animation.prototype, "enable", void 0);
__decorate([
    Property(1000)
], Animation.prototype, "duration", void 0);
__decorate([
    Property(0)
], Animation.prototype, "delay", void 0);
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableMarker", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "shared", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "split", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "followPointer", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "fill", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "header", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "opacity", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontStyle: 'Normal', fontWeight: null, color: null }, Font)
], TooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "template", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableAnimation", void 0);
__decorate([
    Property(300)
], TooltipSettings.prototype, "duration", void 0);
__decorate([
    Property(1000)
], TooltipSettings.prototype, "fadeOutDuration", void 0);
__decorate([
    Property('Move')
], TooltipSettings.prototype, "fadeOutMode", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "enableTextWrap", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "showNearestPoint", void 0);
__decorate([
    Property(0)
], TooltipSettings.prototype, "distance", void 0);
__decorate([
    Complex({ color: null, width: null }, Border)
], TooltipSettings.prototype, "border", void 0);
__decorate([
    Complex({ x: null, y: null }, Location)
], TooltipSettings.prototype, "location", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "enableHighlight", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "showNearestTooltip", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "showHeaderLine", void 0);
/**
 * This class configures the appearance and behavior of points with empty data in the series.
 */
export class EmptyPointSettings extends ChildProperty {
}
__decorate([
    Property(null)
], EmptyPointSettings.prototype, "fill", void 0);
__decorate([
    Complex({ color: '', width: 0 }, Border)
], EmptyPointSettings.prototype, "border", void 0);
__decorate([
    Property('Gap')
], EmptyPointSettings.prototype, "mode", void 0);
/**
 * Specifies the indexes for the series and data points.
 *
 * @public
 */
export class Indexes extends ChildProperty {
}
__decorate([
    Property(0)
], Indexes.prototype, "series", void 0);
__decorate([
    Property(0)
], Indexes.prototype, "point", void 0);
/**
 * The `CornerRadius` class provides options to customize the rounding of the corners for columns in the column series.
 */
export class CornerRadius extends ChildProperty {
}
__decorate([
    Property(0)
], CornerRadius.prototype, "topLeft", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "topRight", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "bottomLeft", void 0);
__decorate([
    Property(0)
], CornerRadius.prototype, "bottomRight", void 0);
/**
 * Configures the padding around the chart legend container.
 */
export class ContainerPadding extends ChildProperty {
}
__decorate([
    Property(0)
], ContainerPadding.prototype, "left", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "right", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "top", void 0);
__decorate([
    Property(0)
], ContainerPadding.prototype, "bottom", void 0);
/**
 * Configures the borders of the chart title and subtitle.
 */
export class titleBorder extends ChildProperty {
}
__decorate([
    Property('transparent')
], titleBorder.prototype, "color", void 0);
__decorate([
    Property(0)
], titleBorder.prototype, "width", void 0);
__decorate([
    Property(0.8)
], titleBorder.prototype, "cornerRadius", void 0);
/**
 * The `titleSettings` class provides options to customize the title and subtitle displayed in the chart.
 */
export class titleSettings extends ChildProperty {
}
__decorate([
    Property('Normal')
], titleSettings.prototype, "fontStyle", void 0);
__decorate([
    Property('15px')
], titleSettings.prototype, "size", void 0);
__decorate([
    Property('500')
], titleSettings.prototype, "fontWeight", void 0);
__decorate([
    Property('')
], titleSettings.prototype, "color", void 0);
__decorate([
    Property('Center')
], titleSettings.prototype, "textAlignment", void 0);
__decorate([
    Property('Segoe UI')
], titleSettings.prototype, "fontFamily", void 0);
__decorate([
    Property(1)
], titleSettings.prototype, "opacity", void 0);
__decorate([
    Property('Wrap')
], titleSettings.prototype, "textOverflow", void 0);
__decorate([
    Property('Top')
], titleSettings.prototype, "position", void 0);
__decorate([
    Property(0)
], titleSettings.prototype, "x", void 0);
__decorate([
    Property(0)
], titleSettings.prototype, "y", void 0);
__decorate([
    Property('transparent')
], titleSettings.prototype, "background", void 0);
__decorate([
    Complex({}, titleBorder)
], titleSettings.prototype, "border", void 0);
__decorate([
    Complex({}, Accessibility)
], titleSettings.prototype, "accessibility", void 0);
/**
 * The `TitleStyleSettings` class provides options to customize the title and subtitle displayed in the accumulation chart.
 */
export class TitleStyleSettings extends Font {
}
__decorate([
    Property('Top')
], TitleStyleSettings.prototype, "position", void 0);
__decorate([
    Property(0)
], TitleStyleSettings.prototype, "x", void 0);
__decorate([
    Property(0)
], TitleStyleSettings.prototype, "y", void 0);
/**
 * The `ChartArea` class provides properties to customize the appearance and layout of the chart's display area.
 */
export class ChartArea extends ChildProperty {
}
__decorate([
    Complex({}, Border)
], ChartArea.prototype, "border", void 0);
__decorate([
    Property('transparent')
], ChartArea.prototype, "background", void 0);
__decorate([
    Property(1)
], ChartArea.prototype, "opacity", void 0);
__decorate([
    Property(null)
], ChartArea.prototype, "backgroundImage", void 0);
__decorate([
    Property(null)
], ChartArea.prototype, "width", void 0);
__decorate([
    Complex({ left: 0, right: 0, top: 0, bottom: 0 }, Margin)
], ChartArea.prototype, "margin", void 0);
/**
 * Configures the drag settings for series in the chart.
 */
export class DragSettings extends ChildProperty {
}
__decorate([
    Property(false)
], DragSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "minY", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "maxY", void 0);
__decorate([
    Property(null)
], DragSettings.prototype, "fill", void 0);
/**
 * Configures the button settings in period selector.
 */
export class Periods extends ChildProperty {
}
__decorate([
    Property('Years')
], Periods.prototype, "intervalType", void 0);
__decorate([
    Property(1)
], Periods.prototype, "interval", void 0);
__decorate([
    Property(null)
], Periods.prototype, "text", void 0);
__decorate([
    Property(false)
], Periods.prototype, "selected", void 0);
/**
 * Configures the period selector settings.
 */
export class PeriodSelectorSettings extends ChildProperty {
}
__decorate([
    Property(43)
], PeriodSelectorSettings.prototype, "height", void 0);
__decorate([
    Property('Bottom')
], PeriodSelectorSettings.prototype, "position", void 0);
__decorate([
    Collection([], Periods)
], PeriodSelectorSettings.prototype, "periods", void 0);
export class StockTooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], StockTooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(true)
], StockTooltipSettings.prototype, "enableMarker", void 0);
__decorate([
    Property(false)
], StockTooltipSettings.prototype, "shared", void 0);
__decorate([
    Property(null)
], StockTooltipSettings.prototype, "fill", void 0);
__decorate([
    Property(null)
], StockTooltipSettings.prototype, "header", void 0);
__decorate([
    Property(0.75)
], StockTooltipSettings.prototype, "opacity", void 0);
__decorate([
    Complex({ fontFamily: null, size: '12px', fontStyle: 'Normal', fontWeight: null, color: null }, Font)
], StockTooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], StockTooltipSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], StockTooltipSettings.prototype, "template", void 0);
__decorate([
    Property(true)
], StockTooltipSettings.prototype, "enableAnimation", void 0);
__decorate([
    Property(300)
], StockTooltipSettings.prototype, "duration", void 0);
__decorate([
    Property(1000)
], StockTooltipSettings.prototype, "fadeOutDuration", void 0);
__decorate([
    Property('Move')
], StockTooltipSettings.prototype, "fadeOutMode", void 0);
__decorate([
    Property(false)
], StockTooltipSettings.prototype, "enableTextWrap", void 0);
__decorate([
    Property(true)
], StockTooltipSettings.prototype, "showNearestPoint", void 0);
__decorate([
    Complex({ color: null, width: null }, Border)
], StockTooltipSettings.prototype, "border", void 0);
__decorate([
    Property('Fixed')
], StockTooltipSettings.prototype, "position", void 0);
__decorate([
    Property(false)
], StockTooltipSettings.prototype, "showNearestTooltip", void 0);
__decorate([
    Property(true)
], StockTooltipSettings.prototype, "showHeaderLine", void 0);
/**
 * Represents a color stop in a gradient.
 */
export class GradientColorStop extends ChildProperty {
}
__decorate([
    Property(0)
], GradientColorStop.prototype, "offset", void 0);
__decorate([
    Property('')
], GradientColorStop.prototype, "color", void 0);
__decorate([
    Property(1)
], GradientColorStop.prototype, "opacity", void 0);
__decorate([
    Property(0)
], GradientColorStop.prototype, "brighten", void 0);
__decorate([
    Property(0)
], GradientColorStop.prototype, "lighten", void 0);
/**
 * Represents a linear gradient configuration.
 */
export class LinearGradient extends ChildProperty {
}
__decorate([
    Property(0)
], LinearGradient.prototype, "x1", void 0);
__decorate([
    Property(0)
], LinearGradient.prototype, "y1", void 0);
__decorate([
    Property(1)
], LinearGradient.prototype, "x2", void 0);
__decorate([
    Property(1)
], LinearGradient.prototype, "y2", void 0);
__decorate([
    Collection([], GradientColorStop)
], LinearGradient.prototype, "gradientColorStop", void 0);
/**
 * Represents a radial gradient configuration.
 */
export class RadialGradient extends ChildProperty {
}
__decorate([
    Property(0.5)
], RadialGradient.prototype, "cx", void 0);
__decorate([
    Property(0.5)
], RadialGradient.prototype, "cy", void 0);
__decorate([
    Property(0.5)
], RadialGradient.prototype, "r", void 0);
__decorate([
    Property(null)
], RadialGradient.prototype, "fx", void 0);
__decorate([
    Property(null)
], RadialGradient.prototype, "fy", void 0);
__decorate([
    Collection([], GradientColorStop)
], RadialGradient.prototype, "gradientColorStop", void 0);
/**
 * @private
 */
export class Index {
    constructor(seriesIndex, pointIndex) {
        this.series = seriesIndex;
        this.point = pointIndex;
    }
}
